import { createRoot } from "react-dom/client";

const ReactRender = (component, querySelector) => {
    const selector = querySelector;

    if (selector) {
        const root = createRoot(selector);
        root.render(component);
    }
};

export default ReactRender;